/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Doc_Claim_NoticeInputs */

const en_case_doc_claim_notice = /** @type {(inputs: Case_Doc_Claim_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claim notice`)
};

const pt_br2_case_doc_claim_notice = /** @type {(inputs: Case_Doc_Claim_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso de sinistro`)
};

/**
* | output |
* | --- |
* | "Claim notice" |
*
* @param {Case_Doc_Claim_NoticeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_doc_claim_notice = /** @type {((inputs?: Case_Doc_Claim_NoticeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Doc_Claim_NoticeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_doc_claim_notice(inputs)
	return pt_br2_case_doc_claim_notice(inputs)
});